<section class="h-full xl:min-h-0 xl:grid xl:grid-rows-[auto_minmax(0,1fr)] gap-4 xl:overflow-hidden">
      <div class="flex flex-wrap items-center justify-between gap-3">
        <page-title [title]="title()" />
        <div class="flex items-center gap-2">
          <ng-content select="[layoutActions]" />
          @if (backLabel()) {
            <button matButton="filled" class="mom-danger" (click)="back.emit()">{{ backLabel() }}</button>
          }
        </div>
      </div>

      <div class="grid xl:min-h-0 xl:auto-rows-fr gap-4 items-stretch xl:overflow-hidden"
           [class]="gridClass()">
        <ng-content />
      </div>
</section>
